<p-toast position="top-right" key="br">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column align-items-start" style="flex: 1">
      <i class="fa-solid fa-check"></i>
      <div class="font-medium text-xs my-1">{{ message.detail }}</div>
    </div>
  </ng-template>
</p-toast>
